/* Worry-Free Shipping cart add-on — HollerBorn (2026-09-17)
 *
 * Loaded from layout/theme.liquid, NOT from the snippet. The cart drawer's contents arrive after page load
 * (section rendering + morphing), and a <script> inside injected HTML never executes — which is why the first
 * version fell through to the plain form and navigated to /cart when Michelle ticked the box in the drawer.
 * A document-level delegated listener loaded once in the layout survives every re-render.
 *
 * Behaviour:
 *   - click the box  → set variant 50616449958081 ($1.50) to quantity 1 or 0 via /cart/update.js
 *                      (ABSOLUTE by variant: never increments, adds the line if missing, never uses line numbers).
 *                      /cart/add.js increments (tick→untick→tick left quantity 2) and /cart/change.js 400s when the
 *                      line does not exist yet, so update.js is the only endpoint that does both halves safely.
 *   - PRE-TICKED     → auto-added once per page view when the cart has other items (Michelle 2026-09-17)
 *   - unticking sets a local opt-out so it does NOT come back for that shopper
 *   - every failure path falls back to a reload, and the markup is a real <form> so it still works with JS off
 */
(function () {
  if (window.__wfInit) return;
  window.__wfInit = true;

  var VARIANT = 50616449958081;
  var OPT_OUT = 'wf_optout';
  var autoTried = false;

  function optedOut() {
    try { return window.localStorage.getItem(OPT_OUT) === '1'; } catch (e) { return false; }
  }
  function setOptOut(on) {
    try { on ? window.localStorage.setItem(OPT_OUT, '1') : window.localStorage.removeItem(OPT_OUT); } catch (e) {}
  }
  function host() { return document.querySelector('cart-items-component[data-section-id]'); }

  function apply(row, on) {
    var el = host();
    var sectionId = el ? el.dataset.sectionId : null;
    // /cart/update.js: absolute quantity keyed by VARIANT — adds when missing, removes at 0, never doubles.
    var updates = {};
    updates[VARIANT] = on ? 0 : 1;
    var body = { updates: updates };
    if (sectionId) { body.sections = sectionId; body.sections_url = window.location.pathname; }

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data.sections && sectionId ? data.sections[sectionId] : null;
        var fresh = html
          ? new DOMParser().parseFromString(html, 'text/html')
              .querySelector('cart-items-component[data-section-id="' + sectionId + '"]')
          : null;
        if (!fresh || !el) { window.location.reload(); return; }
        el.replaceWith(fresh);
      })
      .catch(function () { window.location.reload(); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wf-toggle]');
    if (!btn) return;
    var row = btn.closest('[data-wf]');
    if (!row) return;
    e.preventDefault();                 // never let the fallback form navigate
    e.stopPropagation();
    if (btn.disabled) return;
    btn.disabled = true;
    var on = row.dataset.wfOn === 'true';
    setOptOut(on);                      // removing = opt out; adding = opt back in
    apply(row, on);
  });

  // Pre-ticked: add it once per page view unless this shopper removed it before.
  function maybeAutoAdd() {
    if (autoTried || optedOut()) return;
    var row = document.querySelector('[data-wf]');
    if (!row || row.dataset.wfOn === 'true') return;
    if (Number(row.dataset.wfOthers || 0) < 1) return;   // never on an otherwise empty cart
    autoTried = true;
    apply(row, false);
  }

  if (document.readyState !== 'loading') maybeAutoAdd();
  document.addEventListener('DOMContentLoaded', maybeAutoAdd);
  new MutationObserver(maybeAutoAdd).observe(document.documentElement, { childList: true, subtree: true });
})();
